import { AuditsApiBase } from './paymentApi';

class AuditsApi extends AuditsApiBase {

}

export default new AuditsApi();
